<template>
  <section 
  :style="'background-color:'+section.bgColor+'; color:'+section.fontColor" 
  :data-visible="sectionLoaded"
  :class="section.class + ' flex flex-wrap inView-section'">
      <div :class="displayClass(column.width)" v-for="(column, index2) in section.columns" :key="'column'+index2">
          <component :is="block.type+'Block'" v-for="(block, index3) in column.blocks"
            :currentLang="currentLang"
            :block="block" 
            :key="block.type+'-'+index+'–'+index2+'–'+index3"/>
      </div>
  </section>        
</template>

<script>
const ImageBlock = () => import( /* webpackChunkName: "ImageBlock" */ '@/modules/blocks/ImageBlock.vue');
const HeadingBlock = () => import( /* webpackChunkName: "HeadingBlock" */ '@/modules/blocks/HeadingBlock.vue');
const TextBlock = () => import( /* webpackChunkName: "TextBlock" */ '@/modules/blocks/TextBlock.vue');
const VideoBlock = () => import( /* webpackChunkName: "VideoBlock" */ '@/modules/blocks/VideoBlock.vue');
const QuoteBlock = () => import( /* webpackChunkName: "QuoteBlock" */ '@/modules/blocks/QuoteBlock.vue');

import { $scrollview } from 'vue-scrollview'
import loaderHandler  from '@/mixins/loaderHandler.js'
import scrollBehavior  from '@/mixins/scrollBehavior.js'
import axios from 'axios';
const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
}
export default {
  props: ['currentLang', 'section', 'index'],
  name: 'project',
  mixins: [loaderHandler, scrollBehavior],
  components: {
    ImageBlock,
    HeadingBlock,
    TextBlock,
    VideoBlock,
    QuoteBlock,
  },
  data(){
    return {
      layout: [],
      scroll: $scrollview,
      sectionLoaded: false,
    }
  },
  watch:{
    visible(visible){
      if(visible){
        this.sectionLoaded = true;
      }
    },
  },
  methods:{
    displayClass(width){
      if(!width){
        return
      }
      let $class= "";
      switch(width){
        case '1/1':
          $class = 'w_100';
          break;
        case '1/2':
          $class = 'w_50';
          break;
        case '1/3':
          $class = 'w_33';
          break;
        case '2/3':
          $class = 'w_66';
          break;
        default:
          $class = 'w_100';
      }
      return $class;
    },
    editData(page){
      this.layout = [];
      if(!page || page[this.currentLang].mainContent == ""){
        return;
      }
      this.data.layout = page[this.currentLang].mainContent;
      this.data.id = page.id;
      this.parseLayout(this.data)
    },
    parseLayout (data) {
      if(!data){
        return
      }
      let self = this;
      axios.post('/api/parse-layout', data, { auth }
      ).then(function(response) {
        if(response.data.redirection){
          self.$router.push('home');
        }
        self.layout = Object.values(response.data.layout);
      }).catch(error => {
        self.error = error
      });
    },
  },
  computed: {
    project() {
      let project = this.$store.getters.getProjectByUID(this.$route.params.id)
      this.editData(project);
      return project;
    },
    site(){
      return this.$store.state.site;
    }
  },
  mounted(){
    this.emitToApp(false);
    let self = this;
    setTimeout(function(){
      self.isLandingMounted = true
    }, 500);
  },
  beforeDestroy(){
    this.emitToApp(true);
  }
}
</script>

<style lang="scss">

  .bloc--regular{
    padding: 2em;
    @media screen and (min-width:1024px){
      padding: 0;
      > div{
        padding: 5.33333em;
        &.w_66,
        &.w_50,
        &.w_33{
          margin: auto;
        }
        &.w_66:first-child,
        &.w_50:first-child{
          padding-right:3.33333em
        }
        &.w_33:last-child,
        &.w_50:last-child{
          padding-left:3.33333em
        }
        &.w_33:nth-child(2){
          padding-right:3.33333em;
          padding-left:3.33333em;
        }
      }
    }
  }

  @media screen and (max-width:1024px){
      .w_33 + .w_66,
      .w_66 + .w_33,
      .w_33 + .w_33,
      .w_50 + .w_50{
        margin-top:2em;
       }
    }


</style>
